// ##############################################################

// #             GENEROVANÝ KÓD, NEMODIFIKOVAT!!!!              #

// #                  2025-11-10T09:33:30Z                      #

// ##############################################################


/**
 * 
 */
enum EAdminAccessRoleTyp {
    ROLE_ADMIN = 'ROLE_ADMIN', 
    ROLE_UZIVATEL = 'ROLE_UZIVATEL'
};
export default EAdminAccessRoleTyp;

